export const environment = {
    project_version: '2.0.0',
    project_name: 'iPanda',
    brand: 'iPanda',
    environment: 'development',
    
    production: false,
    feature_x_enabled: true,
    
    language: 'spanish',
    lang: 'es',

    token: 'token_storage_db',
    data_base: 'my_app_admin',
    storage_key: 'my_app_storage_key*',
    api_type: 'nodejs',
    api_version: 'v2',
    api: 'https://dev.api.ipanda.app/',
        
    socket_channel: 'ipanda',
    socket: 'https://socket.apiservices.club',
    socket_bearer_token: 'MS00MGJkMDAxNTYzMDg1ZmMzNTE2NTMyOWVhMWZmNWM1ZWNiZGJiZWVmLXVzZXItMTcwODUzNjEyNy0xNzA4NTQxOTk5',
    
    token_meta: '',
    meta_app_id: '',
    twilio_auth_token: '',
    twilio_account_sid: '',
    google_key:'',
};